module.exports = __webpack_public_path__ + "img/damDeflated.4ca1f51a.svg";